import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Section } from '../components/Section';
import { PostRow } from '../components/PostRow';
import { POSTS_PER_PAGE, PUBLISHED } from '../data/posts';
export function Blog() {
  const [params] = useSearchParams();
  const pageCount = Math.max(1, Math.ceil(PUBLISHED.length / POSTS_PER_PAGE));
  const requested = Number(params.get('page') ?? '1');
  const page = Number.isFinite(requested) ? Math.min(Math.max(1, Math.trunc(requested)), pageCount) : 1;
  const start = (page - 1) * POSTS_PER_PAGE;
  const slice = PUBLISHED.slice(start, start + POSTS_PER_PAGE);

  // The newest post leads page one with its art; the rest read as a dated index.
  const lead = page === 1 ? slice[0] : undefined;
  const rows = lead ? slice.slice(1) : slice;
  return <>
      <Section n="01" label="Signals" id="signals" noTop contentClassName="page-hero" data-id="element-341" data-mp="3glkpy3k8wr0l">
        <h1 className="h1 blog-h1" data-id="element-342" data-mp="3bob04msy2dc8">Field notes from the instruction layer.</h1>
        <p className="lede" style={{
        maxWidth: 900
      }} data-id="element-343" data-mp="225lype19s82u">
          What we’re learning about governing what AI models are told — the moment before the answer, where the obligations either rode
          or they didn’t.
        </p>
      </Section>

      <Section n="02" label={page === 1 ? 'Latest' : 'Archive'} contentClassName="blog-c" data-id="element-344" data-mp="2bvp3sclo1chj">
        {lead && <Link className="feat" to={`/blog/${lead.slug}`} data-id="element-345" data-mp="2fvz71hi2posp">
            {(lead.card ?? lead.hero) && <img src={lead.card ?? lead.hero} alt="" data-id="element-346" data-mp="1j82pa9awgnfw" />}
            <div className="feat-c" data-id="element-347" data-mp="1o52tsfs3pi4w">
              <div className="meta" data-id="element-348" data-mp="1o64ihn21i353">
                <span className="dt" data-id="element-349" data-mp="1s768redzb4ux">{lead.dateLabel.toUpperCase()}</span>
                <span className="ptag" data-id="element-350" data-mp="1s5v5rgscy14v">{lead.category.toUpperCase()}</span>
              </div>
              <div className="t" data-id="element-351" data-mp="1x7kir1z54ovl">{lead.title}</div>
              <div className="b" data-id="element-352" data-mp="33muvc4nbm1v7">{lead.excerpt}</div>
              <div className="go" data-id="element-353" data-mp="33m3ddwmnc2ne">Read it →</div>
            </div>
          </Link>}

        <div className="plist" data-id="element-354" data-mp="38jlamprawtfk">
          {rows.map(post => <PostRow key={post.slug} post={post} withExcerpt data-id="element-355" data-mp="18ieyxv40pvmk" />)}
        </div>

        {pageCount > 1 && <nav className="pager" aria-label="Signals pages" data-id="element-356" data-mp="14gtki5bu59a9">
            {page > 1 ? <Link to={`/blog?page=${page - 1}`} data-id="element-357" data-mp="1ihme8nubc0cb">← NEWER</Link> : <span className="off" data-id="element-358" data-mp="1if9x2cwdpu0b">← NEWER</span>}
            <span data-id="element-359" data-mp="1di026hq80q53">
              PAGE {String(page).padStart(2, '0')} / {String(pageCount).padStart(2, '0')}
            </span>
            {page < pageCount ? <Link to={`/blog?page=${page + 1}`} data-id="element-360" data-mp="pqm9ubs2kuk4">OLDER →</Link> : <span className="off" data-id="element-361" data-mp="kudpmjz0mb63">OLDER →</span>}
          </nav>}
      </Section>
    </>;
}